(function () {
  'use strict';

  if (window.__louloucupProductInit) return;
  window.__louloucupProductInit = true;

  // ─── Config ────────────────────────────────────────────────────────────────

  var STOCK_URGENT = 5;
  var STOCK_INFO   = 15;
  var NBSP = ' ';

  var MODEL_28 = 2890;

  var countryEl = document.getElementById('CartCountryIso');
  var isUS = countryEl
    ? (countryEl.textContent || '').trim().toUpperCase() === 'US'
    : !!(window.Shopify && String(Shopify.country).toUpperCase() === 'US');

  var i18n = isUS ? {
    chooseSizeFirst: 'Choose a size first ↑',
    addToCart: 'Add to cart',
    chooseSize: 'Choose your size',
    soldOut: 'This size is sold out.',
    soldOutHtml: '❌ This size is sold out · <a href="#notify">Notify me when it\'s back</a>',
    stockUrgent: function (stock) { return '🔥 Only ' + stock + ' left — hurry!'; },
    stockInfo: function (stock, sizeLabel) { return '⚡ Only ' + stock + ' left in size ' + sizeLabel; },
    addFailed: 'Couldn\'t add to cart. Try again.',
    seeMore: 'See more ↓',
    seeLess: 'See less ↑',
    cartMax: function (fmtFn) {
      return 'You\'ve unlocked the max discount. Mix with styles from ' +
        fmtFn(MODEL_28) + ' for ' + fmtFn(Math.round(MODEL_28 * 0.79)) + ' each';
    },
    cartQty3: function (fmtFn, price) { return '1 more pair for the best price: ' + fmtFn(price) + ' each (-21%)'; },
    cartQty2: function (fmtFn, price) { return '1 more pair to get to ' + fmtFn(price) + ' each'; },
    cartQty1: function (fmtFn, price) { return '1 more pair to get to ' + fmtFn(price) + ' each (-11%)'; },
    cartQty0: function (fmtFn, saving, next) { return 'Add 1 pair to save ' + fmtFn(saving) + ' (down to ' + fmtFn(next) + ' each)'; }
  } : {
    chooseSizeFirst: "Choisis d'abord ta taille ↑",
    addToCart: 'Ajouter au panier',
    chooseSize: 'Choisis ta taille',
    soldOut: 'Cette taille est épuisée.',
    soldOutHtml: '❌ Cette taille est épuisée · <a href="#notify">Me prévenir du retour</a>',
    stockUrgent: function (stock) { return '🔥 Plus que ' + stock + ' — dépêche-toi !'; },
    stockInfo: function (stock, sizeLabel) { return '⚡ Plus que ' + stock + ' en stock pour la taille ' + sizeLabel; },
    addFailed: 'Impossible d\'ajouter au panier. Réessaie.',
    seeMore: 'Voir plus ↓',
    seeLess: 'Voir moins ↑',
    cartMax: function (fmtFn) {
      return 'Bravo ! Tu as la remise max. Mixe avec des modèles à ' +
        fmtFn(MODEL_28) + ' pour ' + fmtFn(Math.round(MODEL_28 * 0.79)) + '/u';
    },
    cartQty3: function (fmtFn, price) { return "Plus qu’1 article pour le meilleur prix : " + fmtFn(price) + '/u (-21 %)'; },
    cartQty2: function (fmtFn, price) { return "Plus qu’1 article pour passer à " + fmtFn(price) + '/u'; },
    cartQty1: function (fmtFn, price) { return "Plus qu’1 article pour passer à " + fmtFn(price) + '/u (-11 %)'; },
    cartQty0: function (fmtFn, saving, next) { return 'Ajoute 1 article pour économiser ' + fmtFn(saving) + ' (passe à ' + fmtFn(next) + '/u)'; }
  };

  // ─── DOM refs ──────────────────────────────────────────────────────────────

  var msgEl      = document.getElementById('louloucup-cart-message');
  var sheetMsgEl = document.getElementById('louloucup-sheet-cart-message');
  var baseCents  = msgEl ? parseInt(msgEl.dataset.basePrice, 10) : 0;

  // ─── Price formatting (mirrors louloucup-format.js) ────────────────────────

  var priceLocale = (document.documentElement.getAttribute('lang') || 'fr').toLowerCase();
  var useCommaDecimal = priceLocale === 'fr' ||
    priceLocale.indexOf('fr-') === 0 ||
    priceLocale.indexOf('fr_') === 0;

  function fmt(cents) {
    var whole = Math.floor(cents / 100);
    var rem   = cents % 100;
    var frac  = (rem < 10 ? '0' : '') + rem;
    if (isUS) {
      return '$' + whole + '.' + frac;
    }
    var sep = useCommaDecimal ? ',' : '.';
    return whole + sep + frac + NBSP + '€';
  }

  // Keep theme variant-price updates on FR redesign PDPs (ATC already uses fmt).
  // US keeps Shopify's market money format so prices stay in USD.
  function patchThemeMoneyFormat() {
    if (isUS) return;
    if (!document.querySelector('.louloucup-redesign-active')) return;
    if (!window.theme || !theme.Currency || typeof theme.Currency.formatMoney !== 'function') return;
    var original = theme.Currency.formatMoney;
    theme.Currency.formatMoney = function (cents) {
      if (typeof cents === 'string') {
        cents = cents.replace('.', '');
      }
      cents = parseInt(cents, 10);
      if (isNaN(cents)) return original.apply(this, arguments);
      return fmt(cents);
    };
  }
  patchThemeMoneyFormat();
  document.addEventListener('DOMContentLoaded', patchThemeMoneyFormat);

  // ─── Tier unit price (mirrors louloucup-pricing-tiers.js) ──────────────────

  var TIER_DISCOUNTS = [
    { minQty: 2, discountCents: 400  },
    { minQty: 3, discountCents: 1080 },
    { minQty: 4, discountCents: 1600 },
  ];

  function tierUnitPrice(base, qty) {
    if (qty >= 5) return Math.round(base * 0.79);
    for (var i = TIER_DISCOUNTS.length - 1; i >= 0; i--) {
      if (qty >= TIER_DISCOUNTS[i].minQty) {
        return Math.round((base * qty - TIER_DISCOUNTS[i].discountCents) / qty);
      }
    }
    return base;
  }

  // ─── Cart message text (mirrors louloucup-cart-message.js) ─────────────────

  function cartMessageText(qty, base) {
    if (qty >= 5) {
      return i18n.cartMax(fmt);
    }
    if (qty === 3) {
      return i18n.cartQty3(fmt, tierUnitPrice(base, 5));
    }
    if (qty === 2) {
      return i18n.cartQty2(fmt, tierUnitPrice(base, 4));
    }
    if (qty === 1) {
      return i18n.cartQty1(fmt, tierUnitPrice(base, 3));
    }
    var saving = base - tierUnitPrice(base, 2);
    return i18n.cartQty0(fmt, saving, tierUnitPrice(base, 2));
  }

  // ─── Dynamic cart message ──────────────────────────────────────────────────

  function updateCartMessage(itemCount) {
    var text = cartMessageText(itemCount, baseCents);
    if (msgEl) {
      msgEl.textContent = text;
      msgEl.style.display = 'block';
    }
    if (sheetMsgEl) {
      sheetMsgEl.textContent = text;
    }
  }

  function getHeroForm() {
    if (!heroEl) return null;
    return heroEl.querySelector('form[action*="/cart/add"]');
  }

  function getHeroVariants() {
    if (!heroEl) return [];
    var el = heroEl.querySelector('[data-variant-json]');
    if (!el) return [];
    try { return JSON.parse(el.textContent); } catch (e) { return []; }
  }

  function findVariantById(variantId) {
    var id = Number(variantId);
    var variants = getHeroVariants();
    for (var i = 0; i < variants.length; i++) {
      if (variants[i].id === id) return variants[i];
    }
    return null;
  }

  function ensureFormQuantity(form, quantity) {
    var qty = quantity || 1;
    var qtyInput = form.querySelector('[name="quantity"]');
    if (!qtyInput) {
      var formId = (form.getAttribute('id') || '').trim();
      if (formId) {
        qtyInput = document.querySelector('[name="quantity"][form="' + formId + '"]');
      }
    }
    if (qtyInput) {
      qtyInput.value = String(qty);
      return;
    }
    var hidden = form.querySelector('input[data-louloucup-qty]');
    if (!hidden) {
      hidden = document.createElement('input');
      hidden.type = 'hidden';
      hidden.name = 'quantity';
      hidden.setAttribute('data-louloucup-qty', '');
      form.appendChild(hidden);
    }
    hidden.value = String(qty);
  }

  function syncHeroFormFromVariantId(variantId) {
    var variant = findVariantById(variantId);
    if (!variant || !heroEl) return null;

    heroVariantChosen = true;
    var form = getHeroForm();
    if (!form) return null;

    var select = form.querySelector('[data-product-select]');
    if (select) select.value = String(variantId);

    var lastInput = null;
    ['option1', 'option2', 'option3'].forEach(function (key, idx) {
      var val = variant[key];
      if (!val) return;
      var index = 'option' + (idx + 1);
      heroEl.querySelectorAll('[data-variant-input][data-index="' + index + '"]').forEach(function (input) {
        var isMatch = input.value === val;
        input.checked = isMatch;
        if (isMatch) lastInput = input;
      });
      heroEl.querySelectorAll('.variant-input[data-index="' + index + '"]').forEach(function (el) {
        var input = el.querySelector('[data-variant-input]');
        el.classList.toggle('is-selected', !!(input && input.checked));
      });
    });

    if (lastInput) {
      lastInput.dispatchEvent(new Event('change', { bubbles: true }));
    } else {
      updateHeroCta(variant);
    }

    return variant;
  }

  function submitHeroAddToCart(variantId, quantity) {
    return new Promise(function (resolve, reject) {
      var form = getHeroForm();
      if (!form) {
        reject(new Error('no form'));
        return;
      }

      var variant = syncHeroFormFromVariantId(variantId);
      if (!variant) {
        reject(new Error('invalid variant'));
        return;
      }
      if (!variant.available) {
        reject(new Error(i18n.soldOut));
        return;
      }

      ensureFormQuantity(form, quantity);

      var ctaBtn = form.querySelector('[data-add-to-cart]');
      if (!ctaBtn) {
        reject(new Error('no cta'));
        return;
      }

      ctaBtn.disabled = false;
      ctaBtn.classList.remove('louloucup-hero-cta--disabled');

      var timeout = setTimeout(function () {
        cleanup();
        reject(new Error('timeout'));
      }, 15000);

      function cleanup() {
        clearTimeout(timeout);
        document.removeEventListener('ajaxProduct:added', onAdded);
        document.removeEventListener('ajaxProduct:error', onError);
      }

      function onAdded() {
        cleanup();
        resolve();
      }

      function onError(e) {
        cleanup();
        var msg = e && e.detail && e.detail.errorMessage;
        reject(new Error(msg || 'add failed'));
      }

      document.addEventListener('ajaxProduct:added', onAdded);
      document.addEventListener('ajaxProduct:error', onError);

      if (typeof form.requestSubmit === 'function') {
        form.requestSubmit(ctaBtn);
      } else {
        ctaBtn.click();
      }
    });
  }

  function fetchCartAndUpdate() {
    fetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) { updateCartMessage(cart.item_count); })
      .catch(function () {}); // silent fail — message stays hidden
  }

  // ─── Stock message for existing variant picker ─────────────────────────────
  // Listens to Shopify's variant change event and injects a stock message
  // below the size selector using the existing .louloucup-stock-msg element.

  function stockMessage(stock, sizeLabel) {
    if (stock == null || stock === '' || isNaN(Number(stock))) {
      return null;
    }
    stock = Number(stock);
    if (stock <= 0) {
      return { text: i18n.soldOutHtml, urgent: false };
    }
    if (stock <= STOCK_URGENT) {
      return { text: i18n.stockUrgent(stock), urgent: true };
    }
    if (stock <= STOCK_INFO) {
      return { text: i18n.stockInfo(stock, sizeLabel), urgent: false };
    }
    return null; // nothing shown for 16+
  }

  function injectStockMsg(stock, sizeLabel) {
    var el = document.querySelector('.louloucup-stock-msg');
    if (!el) return;
    var msg = stockMessage(stock, sizeLabel);
    if (!msg) {
      el.innerHTML = '';
      return;
    }
    el.innerHTML = msg.text; // safe: msg.text is hardcoded, never user input
    el.className = 'louloucup-stock-msg' + (msg.urgent ? ' louloucup-stock-msg--urgent' : '');
  }

  function clearSheetStockMsg() {
    var el = document.getElementById('louloucup-sheet-stock-msg');
    if (!el) return;
    el.innerHTML = '';
    el.className = 'louloucup-sheet__stock';
  }

  function injectSheetStockMsg(stock, sizeLabel) {
    var el = document.getElementById('louloucup-sheet-stock-msg');
    if (!el) return;
    var msg = stockMessage(stock, sizeLabel);
    if (!msg) {
      el.innerHTML = '';
      el.className = 'louloucup-sheet__stock';
      return;
    }
    el.innerHTML = msg.text;
    el.className = 'louloucup-sheet__stock' + (msg.urgent ? ' louloucup-sheet__stock--urgent' : '');
  }

  function clearSheetError() {
    var err = document.getElementById('louloucup-sheet-error');
    if (err) err.textContent = '';
  }

  function showSheetError(message) {
    var err = document.getElementById('louloucup-sheet-error');
    if (err) err.textContent = message;
  }

  // ─── Mobile sticky cart ───────────────────────────────────────────────────────

  var stickyCart         = document.getElementById('louloucup-sticky-cart');
  var stickyAddBtn       = document.getElementById('louloucup-sticky-add');
  var stickyPreviewBtn   = document.querySelector('[data-louloucup-sticky-preview]');
  var sheetEl            = document.getElementById('louloucup-bottom-sheet');
  var sheetAddBtn        = document.getElementById('louloucup-sheet-add');
  var sheetQtyValue      = document.querySelector('[data-louloucup-sheet-qty-value]');
  var sheetSizeBtns      = document.querySelectorAll('.louloucup-sheet__size');
  var selectedVariantId  = null;
  var selectedVariantPrice = null;
  var sheetQty           = 1;
  var heroEl             = document.querySelector('[data-louloucup-hero]');
  var heroVariantChosen  = false;
  var sheetInitialized   = false;
  var sheetHistoryActive = false;
  var stickyObserver     = null;

  function updateHeroCta(variant) {
    if (!heroEl) return;
    var ctaBtn  = heroEl.querySelector('[data-add-to-cart]');
    var ctaText = heroEl.querySelector('[data-add-to-cart-text]');
    if (!ctaBtn || !ctaText) return;

    if (!heroVariantChosen || !variant) {
      ctaBtn.disabled = false;
      ctaBtn.setAttribute('aria-disabled', 'true');
      ctaBtn.classList.add('louloucup-hero-cta--disabled');
      ctaText.textContent = i18n.chooseSizeFirst;
      selectedVariantId = null;
      selectedVariantPrice = null;
      updateStickyAffordance();
      return;
    }

    ctaBtn.classList.remove('louloucup-hero-cta--disabled');
    ctaBtn.removeAttribute('aria-disabled');
    ctaBtn.disabled = !variant.available;
    ctaText.textContent = i18n.addToCart + ' — ' + fmt(variant.price);
    if (variant.available) {
      selectedVariantId = variant.id;
      selectedVariantPrice = variant.price;
    }
    syncSheetFromVariant(variant);
    updateStickyAffordance();
  }

  function updateStickyAffordance() {
    if (!stickyAddBtn) return;
    var needsSize = !selectedVariantId;
    stickyAddBtn.classList.toggle('louloucup-sticky-cart__btn--needs-size', needsSize);
    stickyAddBtn.setAttribute('aria-expanded', String(isSheetOpen()));
  }

  function clearHeroVariantSelection() {
    if (!heroEl) return;
    heroEl.querySelectorAll('[data-variant-input]').forEach(function (input) {
      input.checked = false;
    });
    heroEl.querySelectorAll('.variant-input').forEach(function (el) {
      el.classList.remove('is-selected');
    });
    var select = heroEl.querySelector('[data-product-select]');
    if (select) {
      var placeholder = document.createElement('option');
      placeholder.value = '';
      placeholder.textContent = '—';
      if (select.options.length && select.options[0].value !== '') {
        select.insertBefore(placeholder, select.options[0]);
      }
      select.value = '';
    }
  }

  function initHeroCta() {
    if (!heroEl) return;
    clearHeroVariantSelection();
    updateHeroCta(null);

    heroEl.querySelectorAll('[data-variant-input]').forEach(function (input) {
      input.addEventListener('change', function () {
        heroVariantChosen = true;
      });
    });

    var ctaBtn = heroEl.querySelector('[data-add-to-cart]');
    if (ctaBtn) {
      ctaBtn.addEventListener('click', function (e) {
        var needsSize = ctaBtn.classList.contains('louloucup-hero-cta--disabled')
          || ctaBtn.getAttribute('aria-disabled') === 'true';
        if (needsSize || ctaBtn.disabled) {
          if (needsSize) {
            e.preventDefault();
            e.stopImmediatePropagation();
            var sizeEl = heroEl.querySelector('.variantcustomprdctdetail');
            if (sizeEl) {
              sizeEl.scrollIntoView({ behavior: 'smooth', block: 'center' });
              sizeEl.classList.remove('louloucup-size-pulse');
              // Force reflow so the animation can restart
              void sizeEl.offsetWidth;
              sizeEl.classList.add('louloucup-size-pulse');
              window.setTimeout(function () {
                sizeEl.classList.remove('louloucup-size-pulse');
              }, 1200);
            }
          }
        }
      }, true);
    }
  }

  // Single variant:change listener handles stock message and variant tracking.
  // Theme dispatches variant:change synchronously from its own input `change`
  // handler, which is registered before ours — so we must mark the size as
  // chosen here (not only on our later input listener), or the first click
  // updates ?variant= in the URL while the CTA stays on "Choisis d'abord…".
  document.addEventListener('variant:change', function (e) {
    var variant = e.detail && e.detail.variant;
    if (!variant) return;
    heroVariantChosen = true;
    injectStockMsg(variant.inventory_quantity, variant.title);
    if (heroEl) {
      updateHeroCta(variant);
    } else {
      selectedVariantId = variant.id;
      selectedVariantPrice = variant.price;
    }
    syncSheetFromVariant(variant);
    updateStickyAffordance();
  });

  function setStickyVisible(visible) {
    if (!stickyCart) return;
    stickyCart.classList.toggle('louloucup-sticky-cart--visible', visible);
    stickyCart.setAttribute('aria-hidden', String(!visible));
  }

  function isMobile() { return window.innerWidth <= 768; }

  function getStickyAnchor() {
    if (!heroEl) return null;
    return heroEl.querySelector('[data-louloucup-sticky-anchor]')
      || heroEl.querySelector('[data-add-to-cart]')
      || heroEl;
  }

  function updateStickyFromAnchor(anchor) {
    if (!anchor || !isMobile()) {
      setStickyVisible(false);
      return;
    }
    var rect = anchor.getBoundingClientRect();
    var heroVisible = rect.bottom > 0 && rect.top < window.innerHeight;
    setStickyVisible(!heroVisible);
  }

  function initStickyObserver() {
    if (!stickyCart) return;
    var anchor = getStickyAnchor();
    if (!anchor) return;

    if ('IntersectionObserver' in window) {
      if (stickyObserver) stickyObserver.disconnect();
      stickyObserver = new IntersectionObserver(function (entries) {
        if (!isMobile()) {
          setStickyVisible(false);
          return;
        }
        setStickyVisible(!entries[0].isIntersecting);
      }, { threshold: 0, rootMargin: '0px 0px -1px 0px' });
      stickyObserver.observe(anchor);
    } else {
      var onScroll = function () {
        updateStickyFromAnchor(anchor);
      };
      window.addEventListener('scroll', onScroll, { passive: true });
      onScroll();
    }

    window.addEventListener('resize', function () {
      if (!isMobile()) setStickyVisible(false);
      else updateStickyFromAnchor(anchor);
    }, { passive: true });

    updateStickyFromAnchor(anchor);
  }

  function handleStickyPurchase() {
    if (selectedVariantId) {
      stickyAddBtn.disabled = true;
      clearSheetError();
      submitHeroAddToCart(selectedVariantId, 1)
        .catch(function () {})
        .then(function () { stickyAddBtn.disabled = false; });
    } else if (sheetEl) {
      openBottomSheet();
    } else {
      var sizeEl = document.querySelector('.variantcustomprdctdetail');
      if (sizeEl) sizeEl.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }
  }

  if (stickyAddBtn) {
    stickyAddBtn.addEventListener('click', handleStickyPurchase);
  }

  if (stickyPreviewBtn) {
    stickyPreviewBtn.addEventListener('click', function () {
      if (!selectedVariantId && sheetEl) {
        openBottomSheet();
      }
    });
  }

  // ─── Bottom sheet ──────────────────────────────────────────────────────────

  var SHEET_CLOSE_MS = 300;
  var SHEET_SWIPE_THRESHOLD = 100;
  var sheetCloseTimer = null;
  var sheetPanelEl = null;

  function portalSheetToBody() {
    if (!sheetEl || sheetEl.parentElement === document.body) return;
    document.body.appendChild(sheetEl);
  }

  function isSheetOpen() {
    return sheetEl && sheetEl.classList.contains('louloucup-sheet--open');
  }

  function restoreStickyFocus() {
    if (document.activeElement && document.activeElement.blur) {
      document.activeElement.blur();
    }
    if (stickyAddBtn && stickyCart && stickyCart.classList.contains('louloucup-sticky-cart--visible')) {
      stickyAddBtn.focus();
    }
  }

  function setSheetQty(qty) {
    sheetQty = Math.max(1, qty);
    if (sheetQtyValue) sheetQtyValue.textContent = String(sheetQty);
  }

  function updateSheetCta() {
    if (!sheetAddBtn) return;
    if (selectedVariantId && selectedVariantPrice) {
      sheetAddBtn.disabled = false;
      sheetAddBtn.textContent = i18n.addToCart;
    } else {
      sheetAddBtn.disabled = true;
      sheetAddBtn.textContent = i18n.chooseSize;
    }
  }

  function clearSheetSizeSelection() {
    sheetSizeBtns.forEach(function (btn) {
      btn.classList.remove('louloucup-sheet__size--selected');
    });
  }

  function syncSheetFromVariant(variant) {
    if (!variant || !sheetEl) return;
    clearSheetSizeSelection();
    sheetSizeBtns.forEach(function (btn) {
      if (String(btn.dataset.variantId) === String(variant.id)) {
        btn.classList.add('louloucup-sheet__size--selected');
      }
    });
    if (variant.inventory_quantity !== undefined) {
      injectSheetStockMsg(variant.inventory_quantity, variant.title || variant.option1 || '');
    }
    updateSheetCta();
  }

  function selectSheetSize(btn) {
    if (!btn || btn.disabled) return;
    clearSheetError();
    clearSheetSizeSelection();
    btn.classList.add('louloucup-sheet__size--selected');
    selectedVariantId = parseInt(btn.dataset.variantId, 10);
    selectedVariantPrice = parseInt(btn.dataset.variantPrice, 10);
    var inventory = parseInt(btn.dataset.inventory, 10);
    var sizeLabel = btn.dataset.sizeLabel || btn.dataset.sizeValue || '';
    injectSheetStockMsg(inventory, sizeLabel);
    syncHeroFormFromVariantId(selectedVariantId);
    updateSheetCta();
    updateStickyAffordance();
  }

  function getSheetFocusables() {
    if (!sheetEl) return [];
    return Array.prototype.slice.call(
      sheetEl.querySelectorAll('button:not([disabled]), [href], input, select, textarea, [tabindex]:not([tabindex="-1"])')
    ).filter(function (el) { return el.offsetParent !== null; });
  }

  function trapSheetFocus(e) {
    if (!isSheetOpen() || e.key !== 'Tab') return;
    var focusables = getSheetFocusables();
    if (!focusables.length) return;
    var first = focusables[0];
    var last = focusables[focusables.length - 1];
    if (e.shiftKey && document.activeElement === first) {
      e.preventDefault();
      last.focus();
    } else if (!e.shiftKey && document.activeElement === last) {
      e.preventDefault();
      first.focus();
    }
  }

  function pushSheetHistory() {
    if (sheetHistoryActive) return;
    history.pushState({ louloucupSheet: true }, '');
    sheetHistoryActive = true;
  }

  function popSheetHistory(skipHistory) {
    if (skipHistory || !sheetHistoryActive) return;
    sheetHistoryActive = false;
    history.back();
  }

  function openBottomSheet() {
    if (!sheetEl || isSheetOpen()) return;
    initBottomSheet();
    if (sheetCloseTimer) {
      clearTimeout(sheetCloseTimer);
      sheetCloseTimer = null;
    }
    clearSheetError();
    setSheetQty(1);
    if (selectedVariantId) {
      syncSheetFromVariant({ id: selectedVariantId, price: selectedVariantPrice });
    } else {
      clearSheetSizeSelection();
      clearSheetStockMsg();
      updateSheetCta();
    }
    portalSheetToBody();
    sheetEl.style.display = 'block';
    sheetEl.setAttribute('aria-hidden', 'false');
    document.body.classList.add('louloucup-sheet-open');
    pushSheetHistory();
    requestAnimationFrame(function () {
      requestAnimationFrame(function () {
        sheetEl.classList.add('louloucup-sheet--open');
        if (sheetPanelEl) sheetPanelEl.style.transform = '';
        fetchCartAndUpdate();
        updateStickyAffordance();
        var closeBtn = sheetEl.querySelector('.louloucup-sheet__close');
        if (closeBtn) closeBtn.focus();
      });
    });
  }

  function closeBottomSheet(skipHistory) {
    if (!sheetEl) return;
    if (!isSheetOpen() && sheetEl.style.display === 'none') return;
    sheetEl.classList.remove('louloucup-sheet--open');
    document.body.classList.remove('louloucup-sheet-open');
    updateStickyAffordance();
    if (sheetPanelEl) {
      sheetPanelEl.style.transform = '';
      sheetEl.classList.remove('louloucup-sheet--dragging');
    }
    if (sheetCloseTimer) clearTimeout(sheetCloseTimer);
    sheetCloseTimer = setTimeout(function () {
      sheetEl.style.display = 'none';
      sheetEl.setAttribute('aria-hidden', 'true');
      sheetCloseTimer = null;
      restoreStickyFocus();
    }, SHEET_CLOSE_MS);
    popSheetHistory(skipHistory);
  }

  function initSheetSwipe() {
    if (!sheetEl || !sheetPanelEl) return;
    var swipeZones = sheetEl.querySelectorAll('[data-louloucup-sheet-swipe]');
    var touchStartY = 0;
    var dragging = false;

    function resetPanel() {
      sheetPanelEl.style.transform = '';
      sheetEl.classList.remove('louloucup-sheet--dragging');
      dragging = false;
    }

    swipeZones.forEach(function (zone) {
      zone.addEventListener('touchstart', function (e) {
        if (!isSheetOpen()) return;
        touchStartY = e.touches[0].clientY;
        dragging = true;
        sheetEl.classList.add('louloucup-sheet--dragging');
      }, { passive: true });

      zone.addEventListener('touchmove', function (e) {
        if (!dragging || !isSheetOpen()) return;
        var delta = Math.max(0, e.touches[0].clientY - touchStartY);
        sheetPanelEl.style.transform = 'translateY(' + delta + 'px)';
      }, { passive: true });

      zone.addEventListener('touchend', function (e) {
        if (!dragging) return;
        var delta = e.changedTouches[0].clientY - touchStartY;
        if (delta > SHEET_SWIPE_THRESHOLD) {
          closeBottomSheet(false);
        } else {
          resetPanel();
        }
      }, { passive: true });

      zone.addEventListener('touchcancel', resetPanel, { passive: true });
    });
  }

  function initBottomSheet() {
    if (sheetInitialized || !sheetEl) return;
    sheetInitialized = true;
    sheetPanelEl = sheetEl.querySelector('.louloucup-sheet__panel');
    sheetSizeBtns = document.querySelectorAll('.louloucup-sheet__size');
    sheetAddBtn = document.getElementById('louloucup-sheet-add');
    sheetQtyValue = document.querySelector('[data-louloucup-sheet-qty-value]');

    sheetEl.querySelectorAll('[data-louloucup-sheet-close]').forEach(function (el) {
      el.addEventListener('click', function (e) {
        e.preventDefault();
        closeBottomSheet(false);
      });
    });

    sheetSizeBtns.forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        selectSheetSize(btn);
      });
    });

    sheetEl.querySelectorAll('[data-louloucup-sheet-qty]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var delta = btn.dataset.louloucupSheetQty === 'plus' ? 1 : -1;
        setSheetQty(sheetQty + delta);
      });
    });

    if (sheetAddBtn) {
      sheetAddBtn.addEventListener('click', function () {
        if (!selectedVariantId) return;
        clearSheetError();
        sheetAddBtn.disabled = true;
        submitHeroAddToCart(selectedVariantId, sheetQty)
          .then(function () { closeBottomSheet(false); })
          .catch(function (err) {
            var msg = err && err.message;
            if (msg && msg !== 'add failed' && msg !== 'timeout' && msg !== 'invalid variant' && msg !== 'no form' && msg !== 'no cta') {
              showSheetError(msg);
            } else {
              showSheetError(i18n.addFailed);
            }
            updateSheetCta();
          });
      });
    }

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && isSheetOpen()) {
        closeBottomSheet(false);
      }
      trapSheetFocus(e);
    });

    window.addEventListener('popstate', function () {
      if (isSheetOpen()) {
        sheetHistoryActive = false;
        closeBottomSheet(true);
      }
    });

    initSheetSwipe();
  }

  // ─── Description expand/collapse ───────────────────────────────────────────

  function sanitizeDescriptionContent() {
    document.querySelectorAll('.louloucup-desc__content').forEach(function (root) {
      root.querySelectorAll('[style]').forEach(function (el) {
        var style = el.getAttribute('style');
        if (!style) return;
        var cleaned = style
          .replace(/(?:^|;)\s*font(?:-size|-family|-stretch|-weight|-style|-kerning)?\s*:[^;]*/gi, '')
          .replace(/(?:^|;)\s*line-height\s*:[^;]*/gi, '')
          .replace(/(?:^|;)\s*min-height\s*:[^;]*/gi, '')
          .replace(/(?:^|;)\s*color\s*:[^;]*/gi, '')
          .replace(/^;+|;+$/g, '')
          .trim();
        if (cleaned) {
          el.setAttribute('style', cleaned);
        } else {
          el.removeAttribute('style');
        }
      });

      root.querySelectorAll('p').forEach(function (p) {
        var text = (p.textContent || '').replace(/\u00a0/g, ' ').trim();
        var onlyBreak =
          text === '' &&
          p.children.length > 0 &&
          Array.prototype.every.call(p.children, function (child) {
            return child.tagName === 'BR';
          });
        if (text === '' || onlyBreak) {
          p.remove();
        }
      });
    });
  }

  function initDescriptionExpand() {
    sanitizeDescriptionContent();
    document.querySelectorAll('[data-louloucup-desc-toggle]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var section = btn.closest('.louloucup-description');
        var panel = section && section.querySelector('[data-louloucup-desc]');
        if (!panel) return;
        var expanded = panel.classList.toggle('louloucup-desc--expanded');
        btn.textContent = expanded ? i18n.seeLess : i18n.seeMore;
        btn.setAttribute('aria-expanded', String(expanded));
      });
    });
  }

  // ─── Init ──────────────────────────────────────────────────────────────────

  var AXEPTIO_STICKY_OFFSET = 'calc(76px + env(safe-area-inset-bottom, 0px))';

  function repositionAxeptio() {
    if (!stickyCart || !isMobile()) return;
    var overlay = document.getElementById('axeptio_overlay');
    if (!overlay) return;
    overlay.style.setProperty('bottom', AXEPTIO_STICKY_OFFSET, 'important');
    overlay.style.setProperty('top', 'auto', 'important');
    overlay.querySelectorAll(':scope > div').forEach(function (el) {
      el.style.setProperty('bottom', AXEPTIO_STICKY_OFFSET, 'important');
      el.style.setProperty('top', 'auto', 'important');
    });
  }

  if (stickyCart) {
    var axeptioAttempts = 0;
    var axeptioRepositionTimer;
    function scheduleAxeptioReposition() {
      clearTimeout(axeptioRepositionTimer);
      axeptioRepositionTimer = setTimeout(repositionAxeptio, 100);
    }
    var axeptioTimer = setInterval(function () {
      repositionAxeptio();
      axeptioAttempts += 1;
      if (axeptioAttempts >= 20) clearInterval(axeptioTimer);
    }, 1000);
    new MutationObserver(scheduleAxeptioReposition).observe(document.body, { childList: true, subtree: true });
    scheduleAxeptioReposition();
  }

  // ─── Trust line → FAQ anchor (smooth scroll + auto-expand) ─────────────────

  var FAQ_SATISFACTION_ID = 'faq-si-elle-ne-me-convient-pas';
  var FAQ_HIGHLIGHT_CLASS = 'louloucup-faq__item--highlight';
  var FAQ_SCROLL_OFFSET = 96; // keep a little air under sticky header
  var FAQ_HIGHLIGHT_MS = 2800;
  var faqHighlightTimer = null;
  var faqHighlightObserver = null;

  function clearFaqHighlight(item) {
    if (faqHighlightTimer) {
      clearTimeout(faqHighlightTimer);
      faqHighlightTimer = null;
    }
    if (faqHighlightObserver) {
      faqHighlightObserver.disconnect();
      faqHighlightObserver = null;
    }
    if (item) item.classList.remove(FAQ_HIGHLIGHT_CLASS);
  }

  function highlightFaqItem(item) {
    clearFaqHighlight(item);
    item.classList.add(FAQ_HIGHLIGHT_CLASS);

    faqHighlightTimer = setTimeout(function () {
      item.classList.remove(FAQ_HIGHLIGHT_CLASS);
      faqHighlightTimer = null;
      if (faqHighlightObserver) {
        faqHighlightObserver.disconnect();
        faqHighlightObserver = null;
      }
    }, FAQ_HIGHLIGHT_MS);

    // Watch for scroll-away only after the smooth scroll settles
    setTimeout(function () {
      if (!item.classList.contains(FAQ_HIGHLIGHT_CLASS)) return;
      if (typeof IntersectionObserver !== 'function') return;
      faqHighlightObserver = new IntersectionObserver(function (entries) {
        var entry = entries[0];
        if (!entry || entry.isIntersecting) return;
        clearFaqHighlight(item);
      }, { threshold: 0.25, rootMargin: '-10% 0px -10% 0px' });
      faqHighlightObserver.observe(item);
    }, 700);
  }

  function scrollToFaqItem(item) {
    var top = item.getBoundingClientRect().top + window.pageYOffset - FAQ_SCROLL_OFFSET;
    window.scrollTo({ top: Math.max(0, top), behavior: 'smooth' });
  }

  function openFaqSatisfaction(shouldScroll) {
    var item = document.getElementById(FAQ_SATISFACTION_ID);
    if (!item) return;
    if (typeof item.open === 'boolean') item.open = true;
    else item.setAttribute('open', '');
    if (shouldScroll) {
      scrollToFaqItem(item);
      // Highlight after layout settles with the open panel
      requestAnimationFrame(function () {
        highlightFaqItem(item);
      });
    }
  }

  function initFaqSatisfactionLink() {
    document.addEventListener('click', function (e) {
      var link = e.target.closest('[data-louloucup-faq-link], a[href="#' + FAQ_SATISFACTION_ID + '"]');
      if (!link) return;
      e.preventDefault();
      if (history.pushState) {
        history.pushState(null, '', '#' + FAQ_SATISFACTION_ID);
      } else {
        window.location.hash = FAQ_SATISFACTION_ID;
      }
      openFaqSatisfaction(true);
    });

    if (window.location.hash === '#' + FAQ_SATISFACTION_ID) {
      // Wait a tick so FAQ is in layout before scrolling
      setTimeout(function () {
        openFaqSatisfaction(true);
      }, 50);
    }
  }

  initDescriptionExpand();
  initFaqSatisfactionLink();
  fetchCartAndUpdate();
  initStickyObserver();
  updateStickyAffordance();

  if (heroEl) {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () {
        setTimeout(function () {
          initHeroCta();
          initStickyObserver();
        }, 150);
      });
    } else {
      setTimeout(function () {
        initHeroCta();
        initStickyObserver();
      }, 150);
    }
  }

  // Re-fetch after any add-to-cart (theme fires this event)
  document.addEventListener('cart:updated', fetchCartAndUpdate);
  document.addEventListener('ajaxProduct:added', fetchCartAndUpdate);
  window.addEventListener('cart:item-added', fetchCartAndUpdate);

})();
